angular.module('wbDashboard').controller('ProfileEmployerControllerAurea', ['$scope', function ($scope) {
    $scope.pageData.errorMsg = null;

    /**
     ***********************************************
     * Updating employer info form
     ***********************************************
     */

    /**
     * Check to see if any section of the form data changed
     */
    $scope.employerChanged = function() {
        return !angular.equals($scope.userDetails, $scope.userDetailsOrig);
    };

    $scope.updateEmployer = function() {
        $scope.userSubmit().finally(function() {
            $scope.forms.employment.$setPristine();
        });
    };

    /**
     * Prevent leaving the page if any data has changed
     */
    var transitionBeforeDeregisterHook = $scope.$transitions.onBefore({exiting: 'base.profile.employer'}, function(trans) {
        if (trans.$to().name !== "public.logout") {
            if ($scope.employerChanged()) {
                if (!confirm("You've changed some of your information, are you sure you want to leave without saving?")) {
                    return false;
                }
            }
        }
    });
    $scope.$on('$destroy', function() {
        if (transitionBeforeDeregisterHook) {
            transitionBeforeDeregisterHook();
        }
    });

}]);
